import LegalsPage from './LegalsPage';
export default LegalsPage;

// import LegalsPageOld from './legalsPageOld';
// export default LegalsPageOld;import LegalsPage from './LegalsPage';
export default LegalsPage;

// import LegalsPageOld from './legalsPageOld';
// export default LegalsPageOld;